module.exports = __webpack_public_path__ + "bc6f6a58b59af2f2ba96442d7d1f34a3.svg";